import React, {useEffect, useContext} from "react";
import { featuresData } from "../utils/features-data";
import FeatureCard from "./feature-card";
import {AuthContext} from "../providers/auth-provider";
import { useNavigate } from "react-router-dom";

const FeatureSection = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  useEffect(() => {
    if (user?.isFirstTimeLogin) {
      navigate("/resetpassword");
    }
  }, [user, navigate]);

  return (
    <div className="w-full min-h-screen bg-[#0f1829] flex flex-col items-center px-4 py-12">
      {/* Header */}
      <div className="w-full max-w-[700px] text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#F05A22]/30 bg-[#F05A22]/10 text-[#F05A22] text-xs font-semibold mb-5 tracking-wide uppercase">
          <span className="w-1.5 h-1.5 rounded-full bg-[#F05A22] animate-pulse" />
          Your Workspace
        </div>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3">
          Welcome back, <span style={{ background: "linear-gradient(135deg, #F05A22, #E8407A)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>{user?.fullName?.split(" ")[0]}</span>
        </h1>
        <p className="text-white/50 text-sm md:text-base">
          Your all-in-one platform to refine, prepare and excel in your career journey.
        </p>
      </div>

      {/* Cards grid */}
      <div className="w-full max-w-[1200px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {featuresData.map((item) => (
          <FeatureCard item={item} key={item.title} />
        ))}
      </div>
    </div>
  );
};

export default FeatureSection;
